import * as React from 'react';
import { Navigate, useOutlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AppBarTop } from './AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import ListItemText from '@mui/material/ListItemText';
import MailIcon from '@mui/icons-material/Mail';
import Toolbar from '@mui/material/Toolbar';
import Logo from '../assets/sebrae-one-blue.png';
import ArticleIcon from '@mui/icons-material/Article';
import SettingsIcon from '@mui/icons-material/Settings';
import AssessmentIcon from '@mui/icons-material/Assessment';
import RequestPageIcon from '@mui/icons-material/RequestPage';
import { useNavigate, useLocation } from 'react-router-dom';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import WebStoriesIcon from '@mui/icons-material/WebStories';
import CampaignIcon from '@mui/icons-material/Campaign';
import PaidIcon from '@mui/icons-material/Paid';
import SummarizeIcon from '@mui/icons-material/Summarize';
import HelpIcon from '@mui/icons-material/Help';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import LoopIcon from '@mui/icons-material/Loop';
import AvisoCalendarioLimiteEnvioNotas from './AvisoCalendarioLimiteEnvioNotas';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import { Button, Checkbox, Modal, Typography } from '@mui/material';

const drawerWidth = 240;

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 900,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export const ProtectedLayout = (props: Props) => {
  const { user, isUsuarioSebrae } = useAuth();
  const outlet = useOutlet();
  const { window } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [naoMostrarPesquisaMais, setNaoMostrarPesquisaMais] =
    React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const showCadastro = process.env.REACT_APP_CADASTRO;

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [open, setOpen] = React.useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  const drawer = (
    <div>
      <Toolbar>
        <img src={Logo} style={{ width: 200, marginTop: 35 }} />
      </Toolbar>

      <List style={{ marginTop: 10 }}>
        {user &&
        user.role_id !== 3 &&
        user.role_id !== 4 &&
        user.role_id !== 6 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/contratos'}
              onClick={() => {
                navigate('/dashboard/contratos', { replace: true });
              }}
            >
              <ListItemIcon>
                <ArticleIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                primary={'Contratos / Pedidos'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {user &&
        user.role_id !== 3 &&
        user.role_id !== 4 &&
        user.role_id !== 6 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/extrato'}
              onClick={() => navigate('/dashboard/extrato', { replace: true })}
            >
              <ListItemIcon>
                <AssessmentIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Extratos'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {user &&
        user.role_id !== 3 &&
        user.role_id !== 4 &&
        user.role_id !== 6 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/painel-notas'}
              onClick={() =>
                navigate('/dashboard/painel-notas', { replace: true })
              }
            >
              <ListItemIcon>
                <WebStoriesIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Painel de Notas'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {user &&
        (user.role_id == 1 ||
          user.role_id == 4 ||
          user.role_id == 2 ||
          user.role_id == 5) ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/informe-rendimentos'}
              onClick={() =>
                navigate('/dashboard/informe-rendimentos', { replace: true })
              }
            >
              <ListItemIcon>
                <PaidIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Informe Rendimentos'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {(isUsuarioSebrae && user && user.role_id !== 4) ||
        user.role_id === 6 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/pagamento-direto'}
              onClick={() =>
                navigate('/dashboard/pagamento-direto', { replace: true })
              }
            >
              <ListItemIcon>
                <RequestPageIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Pagamento direto'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {isUsuarioSebrae && user && user.role_id !== 4 && user.role_id !== 6 ? (
          <>
            <ListItem disablePadding>
              <ListItemButton
                selected={location.pathname === '/dashboard/exportar-notas'}
                onClick={handleClick}
              >
                <ListItemIcon>
                  <SummarizeIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{ fontSize: '0.9rem' }}
                  style={{ color: '#0e72b8' }}
                  primary={'Relatórios'}
                />
                {open ? <ExpandLess /> : <ExpandMore />}
              </ListItemButton>
            </ListItem>

            <Collapse in={open} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItemButton
                  sx={{ pl: 4 }}
                  onClick={() =>
                    navigate('/dashboard/exportar-notas', { replace: true })
                  }
                >
                  <ListItemIcon>
                    <SummarizeIcon color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{ fontSize: '0.9rem' }}
                    primary="Notas Fiscais"
                  />
                </ListItemButton>
                {(user && user.role_id == 1) || user.role_id == 5 ? (
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() =>
                      navigate('/dashboard/informe-rendimentos-relatorio', {
                        replace: true,
                      })
                    }
                  >
                    <ListItemIcon>
                      <SummarizeIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primaryTypographyProps={{ fontSize: '0.9rem' }}
                      primary="Informe Rendimentos"
                    />
                  </ListItemButton>
                ) : null}
              </List>
            </Collapse>
          </>
        ) : null}
        {/* {!isUsuarioSebrae && user && user.role_id !== 1 && user.role_id !== 4 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === `/dashboard/cadastro-fornecedor?fornecedor_id=${user.fornecedor_id}`}
              onClick={() => {
                navigate(`/dashboard/cadastro-fornecedor?fornecedor_id=${user.fornecedor_id}`, { replace: true });
              }}
            >
              <ListItemIcon>
                <ArticleIcon color="primary" />
              </ListItemIcon>
              <ListItemText primary={"Cadastro"} />
            </ListItemButton>
          </ListItem>
        ) : null} */}
        {user && user.role_id === 1 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/layout-xml'}
              onClick={() =>
                navigate('/dashboard/layout-xml', { replace: true })
              }
            >
              <ListItemIcon>
                <AccountTreeIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Criar LayoutXML'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {user && user.role_id === 1 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/logs'}
              onClick={() => navigate('/dashboard/logs', { replace: true })}
            >
              <ListItemIcon>
                <SettingsIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Logs'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {user && user.role_id === 1 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/failed-jobs'}
              onClick={() =>
                navigate('/dashboard/failed-jobs', { replace: true })
              }
            >
              <ListItemIcon>
                <LoopIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary="Reprocessar Jobs"
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {user && user.role_id !== 4 && showCadastro == 'S' ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/listar-cadastros'}
              onClick={() =>
                navigate(
                  isUsuarioSebrae ||
                    (user && user.role_id == 6 && user.cod_usuario != '')
                    ? '/dashboard/listar-cadastros'
                    : `/dashboard/listar-cadastros?fornecedor=${
                        user.cnpj
                          ? user.cnpj.replace(/[^a-zA-Z0-9]/g, '')
                          : user.cpf.replace(/\D/g)
                      }`,
                  { replace: true },
                )
              }
            >
              <ListItemIcon>
                <PersonAddAltIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Cadastro'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {(user && user.role_id === 1) || user.role_id === 5 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/listar-avisos'}
              onClick={() =>
                navigate('/dashboard/listar-avisos', { replace: true })
              }
            >
              <ListItemIcon>
                <CampaignIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Avisos'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {(user && user.role_id === 1) || user.role_id === 5 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/listar-faq'}
              onClick={() =>
                navigate('/dashboard/listar-faq', { replace: true })
              }
            >
              <ListItemIcon>
                <HelpIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Faq'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}
        {(user && user.role_id === 1) || user.role_id === 5 ? (
          <ListItem disablePadding>
            <ListItemButton
              selected={location.pathname === '/dashboard/listar-calendario'}
              onClick={() =>
                navigate('/dashboard/listar-calendario', { replace: true })
              }
            >
              <ListItemIcon>
                <CalendarMonthIcon color="primary" />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{ fontSize: '0.9rem' }}
                style={{ color: '#0e72b8' }}
                primary={'Calendário'}
              />
            </ListItemButton>
          </ListItem>
        ) : null}

        <div style={{ padding: '1rem' }}>
          <AvisoCalendarioLimiteEnvioNotas />
        </div>
      </List>
    </div>
  );

  if (!user) {
    return <Navigate to="/" />;
  }

  const container =
    window !== undefined ? () => window().document.body : undefined;

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <AppBarTop
          onClickToolBar={handleDrawerToggle}
          pages={[{ label: 'Contratos', path: 'contratos' }]}
        />
        <Box
          component="nav"
          sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
          aria-label="mailbox folders"
        >
          {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
          <Drawer
            container={container}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
            sx={{
              display: { xs: 'block', sm: 'none' },
              '& .MuiDrawer-paper': {
                border: 'none',
                boxSizing: 'border-box',
                width: drawerWidth,
              },
            }}
          >
            {drawer}
          </Drawer>
          <Drawer
            variant="permanent"
            sx={{
              display: { xs: 'none', sm: 'block' },
              '& .MuiDrawer-paper': {
                border: 'none',
                boxSizing: 'border-box',
                width: drawerWidth,
              },
            }}
            open
          >
            {drawer}
          </Drawer>
        </Box>
        <Box component="main" style={{ width: '100%' }}>
          {outlet}
        </Box>
      </Box>
    </>
  );
};
